import auctionSuccessTemplate from './templates/auctionPopupSuccess.twig';
import axios from 'axios';
import baseSuccessTemplate from './templates/baseSuccess.twig';
import bookletSuccessTemplate from './templates/bookletPopupSuccess.twig';
import callbackSuccessTemplate from './templates/callbackPopupSuccess.twig';
import Cookie from 'js-cookie';
import CustomSelect from 'components/forms/custom-select';
import {goalsHandler} from '../goals-handler';
import Observer from 'common/scripts/observer';
import quizSuccessTemplate from './templates/quizSuccess.twig';
import requestSuccessTemplate from './templates/requestPopupSuccess.twig';
import {Utils} from 'common/scripts/utils';
import webpushSuccessTemplate from './templates/webpushPopupSuccess.twig';
import History from "components/history";

const SMARTCAPTCHA_KEY = 'ysc1_W5qdp0unrahg9Qrv4EF4pEgLZFMYz9QYeswNljVt93211c7c';

const observer = new Observer();

class Form {
    constructor() {
        this.inputList = [];
    }

    // eslint-disable-next-line max-statements
    init(options) {
        this.wrapper = options.target;
        this.popupInstance = options.popupInstance || null;
        this.form = options.target.querySelector('form');
        this.isVaildation = 'validate' in this.form.dataset;
        this.isStepForm = 'stepValidate' in this.form.dataset;
        this.isRepeatRequest = false;
        this.successMessage = options.successMessage;
        this.successFromTemplate = options.successFromTemplate || false;
        this.successTemplateType = options.successTemplateType || 'base';
        this.successMessageTxt = options.successMessageTxt || false;
        this.action = this.form.getAttribute('action');
        this.mindboxType = this.form.dataset.mindboxType || null;
        this.messageBot = this.form.querySelector('[name="message_bot"]');
        this.counterType = this.wrapper.dataset.counter || false;
        this.criteo = 'criteo' in this.wrapper.dataset;
        this.selects = this.form.querySelectorAll('.j-form__select');
        this.showClass = 'is-active';
        this.readyClass = 'is-ready';
        this.validateClass = 'is-validate';
        this.isDefaultSubmit = 'defsubmit' in this.form.dataset || false;
        this.token = null;
        this.firstStart = true;

        this._getElements();
        this._subscribes();
        this._bindEvents();

        if (this.isStepForm) {
            this._getStepElements();
            this._bindStepEvents();
        }

        this._replaceTitle();
        this._setHiddenInputs();
        this._setHiddenUrl();
        this._setCallTouchID();

        this.initLazyLoadCaptcha();
    }

    /**
     * Метод получает дом элементы.
     * @private
     */
    _getElements() {
        this.submit = this.form.querySelector('.j-form-submit');
        this.submitText = this.submit.querySelector('.button__text');
        this.submitSource = this.submit.dataset.source || false;
        this.formId = this.form.getAttribute('id') || '';
        this.passwordInput = this.form.querySelector('input[type="password"]');
        this.passwordToggleBtn = this.form.querySelector('.j-toggle-pwd');

        if (this.successMessage) {
            this.successMessageWrap = this.wrapper.querySelector('.j-form-success');
            this.errorMessageWrap = this.wrapper.querySelector('.j-form-error');
            this.errorMessageTextWrap = this.errorMessageWrap.querySelector('.j-error-text');
            this.returnForm = Array.from(this.wrapper.querySelectorAll('.j-form-return'));

            if (this.successFromTemplate) {
                switch (this.successTemplateType) {
                    case 'base':
                    default:
                        this.successTemplate = baseSuccessTemplate;
                        break;
                    case 'booklet':
                        this.successTemplate = bookletSuccessTemplate;
                        break;
                    case 'callbackPopup':
                        this.successTemplate = callbackSuccessTemplate;
                        break;
                    case 'request':
                        this.successTemplate = requestSuccessTemplate;
                        break;
                    case 'auction':
                        this.successTemplate = auctionSuccessTemplate;
                        break;
                    case 'quiz':
                        this.successTemplate = quizSuccessTemplate;
                        break;
                    case 'webpush':
                        this.successTemplate = webpushSuccessTemplate;
                        break;
                }
            }
        }
    }

    _subscribes() {
        if (this.isVaildation) {
            observer.subscribe('formIsValid', (form) => {
                if (form === this.form) {
                    if (this.isDefaultSubmit) {
                        this.form.submit();
                    } else {
                        this.checkSmartCaptcha();
                    }
                }
            });
        }
    }

    /**
     * Метод навешивает обработчики событий.
     * @private
     */
    _bindEvents() {
        if (!this.isVaildation) {
            this.submit.addEventListener('click', (event) => {
                if (this.isDefaultSubmit) {
                    this.form.submit();
                } else {
                    event.preventDefault();
                    this.checkSmartCaptcha();
                }
            });
        }

        if (this.returnForm.length) {
            this.returnForm.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    observer.publish('returnForm');
                    this.closeResultMessage();
                });
            });
        }

        if (this.selects.length) {
            this.selects.forEach((item) => {
                const select = new CustomSelect({
                    elem          : item,
                    selectCallback: (value) => {
                        this._changeButtonLink(value);
                    }
                });

                select.init();
            });
        }

        if (this.passwordInput && this.passwordToggleBtn) {
            this._togglePassword();
        }
    }

    /**
     * Метод получает дом элементы шага
     * Устанавливает валидацию на первичный контент
     * Устанавливает продолжительность таймера
     * @private
     */
    _getStepElements() {
        this.initialContent = this.form.querySelector('.j-initial-content');
        this.stepContent = this.form.querySelector('.j-step-content');
        this.phoneField = this.form.querySelector('.j-sms-phone');
        this.smsField = this.form.querySelector('.j-sms-input').querySelector('input');
        this.timerWrapper = this.form.querySelector('.j-sms-timer-wrap');
        this.timerCounter = this.form.querySelector('.j-sms-timer-counter');
        this.stepBack = this.form.querySelector('.j-form-step-back');
        this.repeatRequestWrapper = this.form.querySelector('.j-sms-repeat-request-wrap');
        this.repeatRequest = this.form.querySelector('.j-sms-repeat-request');
        this.codeError = this.form.querySelector('.j-code-error');
        this.initialContent.classList.add(this.validateClass);
        this.counterDuration = 59;
    }

    /**
     * Метод навешивает обработчики событий:
     * - возврат к начальной форме
     * - повторный запрос смс-кода
     * @private
     */
    _bindStepEvents() {
        this.stepBack.addEventListener('click', () => {
            this._stepBack();
        });

        this.repeatRequest.addEventListener('click', (event) => {
            this.isRepeatRequest = true;
            if (this.isDefaultSubmit) {
                this.form.submit();
            } else {
                event.preventDefault();
                this.checkSmartCaptcha(true);
            }
        });
    }

    _scrollToAnswer() {
        if (this.submit.classList.contains('j-scroll-to-answer')) {
            setTimeout(() => {
                if (this.successMessageWrap.classList.contains('is-active')) {
                    this.successMessageWrap.scrollIntoView({
                        behavior: 'smooth',
                        block   : 'center'
                    });
                } else {
                    this.errorMessageWrap.scrollIntoView({
                        behavior: 'smooth',
                        block   : 'center'
                    });
                }
            }, 200);
        }
    }

    /**
     * Метод проверяет находитлся ли форма во вьюпорте
     * если находится, вызывает метод инициализации капчи
     * иначе, откладывает инициализацию до появление формы во вьюпорте
     */
    initLazyLoadCaptcha() {
        if ('IntersectionObserver' in window) {
            const lazyObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.initCaptcha();

                        lazyObserver.unobserve(entry.target);
                    }
                });
            });

            const isHidden = Boolean(this.form.closest('.popup__hidden-content'));
            // eslint-disable-next-line
            const isInViewport = Utils.isInViewport(this.form, window.innerHeight || document.documentElement.clientHeight);

            if (isInViewport && !isHidden) {
                this.initCaptcha();
            } else {
                lazyObserver.observe(this.form);
            }
        } else {
            this.initCaptcha();
        }
    }

    /**
     * Метод инициализирует Яндекс-Капчу
     */
    initCaptcha() {
        if (!window.smartCaptcha) {
            return;
        }

        let captcha = this.form.querySelector('.smart-captcha');

        if (!captcha) {
            captcha = document.createElement('div');
            captcha.className = 'smart-captcha';

            this.form.prepend(captcha);
        }

        this.widgetId = window.smartCaptcha.render(captcha, {
            sitekey   : SMARTCAPTCHA_KEY,
            // eslint-disable-next-line arrow-body-style
            callback  : (token) => this.captchaCallback(token),
            // для отладки - задание может приходить каждый раз
            test      : false,
            // Делает капчу невидимой
            invisible : true,
            // Делает предупреждающую плашку невидимой
            hideShield: true
        });

        this.smartTokenField = this.form.querySelector('input[name="smart-token"]') || null;
    }

    captchaCallback(token) {
        if (token) {
            this.token = token;

            if (this.smartTokenField) {
                this.smartTokenField.value = token;
            }

            this._send();
        } else {
            console.error('no token');

            if (this.smartTokenField) {
                this.smartTokenField.value = '';
            }
        }
    }

    /**
     * Метод запускает Яндекс-капчу перед отправкой формы
     * @param {boolean} isRepeat - повторный запрос капчи
     */
    checkSmartCaptcha(isRepeat = false) {
        if (!window.smartCaptcha) {
            return;
        }

        if (isRepeat) {
            this._resetSmartCaptcha();
        }

        const isFirstStepForm = this.stepContent &&
            !this.stepContent.classList.contains(this.showClass) &&
            !this.stepContent.classList.contains(this.validateClass);

        if (isFirstStepForm || isRepeat) {
            window.smartCaptcha.execute(this.widgetId);
        } else {
            this._send();
        }
        // if ((isFirstStepForm || isRepeat) && this.firstStart) {
        //     window.smartCaptcha.execute(this.widgetId);
        // } else {
        //     this._resetSmartCaptcha();


        //     if (window.smartCaptcha) {
        //         window.smartCaptcha.execute(this.widgetId);

        //         this._send();
        //     }
        // }
    }

    /**
     * Метод отправляет данные на сервер.
     * @private
     */
    /* eslint-disable max-lines-per-function, require-await */
    async _send() {
        if (this._isAllReady()) {
            return;
        }

        // Меняем флаг для того чтобы при изменении номера телефона форма
        // срабатывала снова
        this.firstStart = false;

        this._insertAntiSpam();

        if (this.formId === 'callback-social-utm') {
            this._setHiddenUtmInputs();
        }

        this.formData = new FormData(this.form);
        this.formData.append('stepForm', this.isStepForm);

        if (this.isRepeatRequest) {
            this.formData.set('code', '');
        }

        if (this.criteo) {
            this.formData.append('criteo', this.criteo);
        }

        // await this._checkMindBoxData();

        this.formDataObject = {};
        this.formData.forEach((value, key) => {
            this.formDataObject[key] = value;
        });

        this._insertButtonText('Отправляем...');
        // подменяет экшн если номер заблокирован и ошибка сразу
        // this.action = '/tests/form-step-error-first-step.json';
        // подменяет экшн - успешный первый шаг
        // this.action = '/tests/form-step-success-first-step.json';

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.post(this.action, this.formData)
            .then((response) => {
                const status = response.data.request.status;
                const requestStatus = response.data.data.requestStatus;

                this.isRequestProceeding = Object.prototype.hasOwnProperty.call(response.data.data, 'requestStatus');
                this.formDataResponse = response.data.data;

                if (status) {
                    if (this.isStepForm && !requestStatus) {
                        // eslint-disable-next-line no-unused-expressions
                        this.isRepeatRequest ? this._repeatCountdown() : this._stepHandler();
                    } else {
                        this._sendIsSuccess();
                        this._scrollToAnswer();
                    }
                } else {
                    this.errorMessageText = this.formDataResponse.errorMessage;
                    this.errorMessageType = this.formDataResponse.errorType;
                    throw new Error('Ошибка на сервере при отправке формы');
                }

                this._scrollToStartForm();
            })
            .catch((err) => {
                if (this.isStepForm) {
                    // eslint-disable-next-line no-unused-expressions
                    this.isRequestProceeding ? this._stepSendIsError() : this._sendIsError();
                } else {
                    this._sendIsError();
                }

                this._scrollToStartForm();
                this._scrollToAnswer();
                console.error(err);
            });
    }
    /* eslint-enable */


    /**
     * Пролистывает форму к начала
     * @private
     */
    _scrollToStartForm() {
        if (Utils.isMobile() && !this.popupInstance) {
            const coord = this.wrapper.getBoundingClientRect();

            window.scrollTo({
                top     : coord.top + window.pageYOffset - 120,
                behavior: 'smooth'
            });
        }
    }

    /**
     * Перезагружает смарт капчу
     * @private
     */
    _resetSmartCaptcha() {
        window.smartCaptcha.reset(this.widgetId);
    }

    _isAllReady() {
        return this.wrapper.classList.contains(this.readyClass);
    }

    /**
     * Управляет шагом формы. Метод должен отработать в 2 случаях:
     *  1 - при первичной отправке формы
     *  2 - после изменения номера телефона (при возврате с шага на начало) и повторной отправке
     *  - показывает шаг формы
     *  - заполняет номер телефона, на который отправлен код
     *  - запускает счетчик
     * @private
     */
    _stepHandler() {
        this._fillStepElements();
        this._setCountdown();
        this._showStepTemplate();

        if (this.submitSource) {
            goalsHandler(1, this.submitSource);
        }

        // подменяет экшн на втором шаге для эмуляции ошибки
        // this.action = '/tests/form-step-error.json';

        // подменяет экшн на втором шаге для эмуляции успешного ответа (когда заявка сформирована)
        // this.action = '/tests/form-step-success.json';
    }

    /**
     * Заполняет поля внутри шага: отправленный номер телефона, время таймера
     * @private
     */
    _fillStepElements() {
        Utils.insetContent(this.phoneField, this.formDataObject.phone);
        this.timerCounter.innerHTML = `${this.counterDuration}`;
        this._insertButtonText('Подтвердить код');
    }

    /**
     * Запускает таймер повторного подтверждения смс-кода
     * @private
     */
    _setCountdown() {
        let duration = this.counterDuration;

        this.countdown = setInterval(() => {
            this.timerCounter.innerHTML = `${--duration}`;

            if (duration === 0) {
                this._stopCountdown();
                this._showRepeatRequest();
            }
        }, 1000);
    }

    /**
     * Показывает шаг получения смс-кода
     * @private
     */
    _showStepTemplate() {
        Utils.hide(this.initialContent);
        this.initialContent.classList.remove(this.showClass, this.validateClass);
        this.stepContent.classList.add(this.showClass, this.validateClass);
        Utils.show(this.stepBack);
    }

    /**
     * Делает шаг назад: с шага ввода смс-кода на начальную форму
     * - Очищает контент шага
     * - Останавлявает таймер
     * - Меняет класс для выборки полей при валидациии
     * @private
     */
    _stepBack() {
        this._clearStepContent();
        this._stopCountdown();
        Utils.hide(this.stepBack);
        this.stepContent.classList.remove(this.showClass, this.validateClass);
        this.initialContent.classList.add(this.showClass, this.validateClass);
        this._insertButtonText('Отправить заявку');
        Utils.show(this.initialContent);

        this.initCaptcha();
    }

    /**
     * Останавливает счетчик при возврате к форме
     * @private
     */
    _stopCountdown() {
        clearInterval(this.countdown);
    }

    /**
     * По истечении таймера скрывает таймер и показывает блок обратного запроса
     * @private
     */
    _showRepeatRequest() {
        Utils.hide(this.timerWrapper);
        Utils.show(this.repeatRequestWrapper);
    }

    /**
     * Ощищает шаговую часть формы при возврате к первичной
     * @private
     */
    _clearStepContent() {
        this.submit.classList.remove('is-disabled');
        Utils.clearInline(this.codeError);
        Utils.clearInline(this.timerWrapper);
        Utils.clearInline(this.repeatRequestWrapper);
        Utils.clearHtml(this.phoneField);
        observer.publish('removeInputClass', this.smsField);
    }

    /**
     * Показывает счетчик после повторного запроса кода
     * @private
     */
    _repeatCountdown() {
        this.submit.classList.remove('is-disabled');
        Utils.hide(this.codeError);
        Utils.show(this.timerWrapper);
        Utils.hide(this.repeatRequestWrapper);
        this.isRepeatRequest = false;
        this.timerCounter.innerHTML = `${this.counterDuration}`;
        this._insertButtonText('Подтвердить код');
        this._setCountdown();
    }

    /**
     * Метод вызывается при успешной отправке запроса.
     * @private
     */
    _sendIsSuccess() {
        this.errorMessageWrap.classList.remove(this.showClass);
        this.submit.classList.remove('is-error');

        this._showSuccessMessage();
        this._insertButtonText('Отправлено');
        this.submit.classList.add('is-disabled');
        // this._sendMindboxData(); // старая интеграция Майндбокса
        this._sendHybrid();
        this._sendGA();
        this._sendDataLayer();
        this._sendCriteo();
        this._sendMetrics();
        // новая интеграция Майндбокса
        this._sendMindboxNew();
        this._setCookie();
        this._resetSmartCaptcha();

        if (this.submitSource) {
            goalsHandler(2, this.submitSource);
        }
    }

    /**
     * Метод вызывается при ошибке отправки запроса.
     * @private
     */
    _sendIsError() {
        this._insertButtonText('Повторить отправку');
        this.submit.classList.add('is-error');

        this._showErrorMessage();
    }

    /**
     * Метод вызывается при ошибке отправки смс-кода.
     * @private
     */
    _stepSendIsError() {
        const errorClass = `callback__form-code-error_type_${this.errorMessageType}`;
        // ошибка кода: типы smsTermExpired (время кода вышло) или smsWrongCode (код неверен)
        const isCodeError = this.formDataResponse.errorType !== 'smsLimitExpired';

        this._insertButtonText('Подтвердить код');
        this.submit.classList.add('is-disabled');

        // eslint-disable-next-line no-unused-expressions
        isCodeError ? Utils.show(this.repeatRequestWrapper) : Utils.hide(this.repeatRequestWrapper);

        Utils.hide(this.timerWrapper);
        this._stopCountdown();
        this.codeError.classList.add(errorClass);
        this.codeError.innerHTML = this.errorMessageText;
        Utils.show(this.codeError);

        // подменяет экшн для эмуляции ошибок (для повторного запроса кода)
        // this.action = '/tests/form.json';
    }

    /**
     * Показывает сообщение об успешной отправкой формы.
     * @private
     */
    _showSuccessMessage() {
        this.wrapper.classList.add(this.readyClass);
        this.form.classList.remove(this.showClass);
        if (this.successFromTemplate) {
            this._setSuccessTemplate();
        }
        this.successMessageWrap.classList.add(this.showClass);

        observer.publish('successForm');
    }

    /**
     * Устанавливает успешное сообщение из шаблона
     * @private
     */
    _setSuccessTemplate() {
        const data = Object.assign(this.formDataObject, this.formDataResponse, {message: this.successMessageTxt});

        Utils.clearHtml(this.successMessageWrap);
        Utils.insetContent(this.successMessageWrap, this.successTemplate(data));

        this.returnForm = Array.from(this.wrapper.querySelectorAll('.j-form-return'));
        if (this.returnForm.length) {
            this.returnForm.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    observer.publish('returnForm');
                    this.closeResultMessage();

                    if (this.isStepForm) {
                        this._stepBack();
                    }
                });
            });
        }
    }

    /**
     * Показывает сообщение об ошибке
     * @private
     */
    _showErrorMessage() {
        this.wrapper.classList.add(this.readyClass);
        this.form.classList.remove(this.showClass);
        this.successMessageWrap.classList.remove(this.showClass);

        if (this.errorMessageText) {
            this.errorMessageTextWrap.innerHTML = this.errorMessageText;
        }

        this.errorMessageWrap.classList.add(this.showClass);

        observer.publish('errorForm');
    }

    /**
     * Метод закрывает все сообщения об отправке/неудаче
     */
    closeResultMessage() {
        this.wrapper.classList.remove(this.readyClass);
        this.successMessageWrap.classList.remove(this.showClass);
        this.errorMessageWrap.classList.remove(this.showClass);
        this.form.classList.add(this.showClass);
    }

    /**
     * Метод вставляет текст в кнопку сабмит.
     * @param {string} text - необходимый текст.
     * @private
     */
    _insertButtonText(text) {
        Utils.clearHtml(this.submitText);
        Utils.insetContent(this.submitText, text);
    }

    /**
     * Метод вставляет проверяет форму и UTM-метки.
     * @private
     */
    _checkMindBoxData() {
        this.mindboxUtm = Array.from(new URL(window.location.href).searchParams)
            .filter((n) => {
                return n[0].startsWith('utm_');
            })
            .reduce((acc, n) => {
                return {...acc,
                    [n[0].slice(4)]: n[1]};
            }, {});

        if (this.mindboxUtm.campaign) {
            this.formData.append('NewsAlias', this.mindboxUtm.campaign.split('_')[0]);
        }
    }

    /**
     * Метод вставляет скрытое поле с антиспамом
     */
    _insertAntiSpam() {
        if (this.messageBot) {
            const minRandom = 1;
            const maxRandom = 10;

            this.messageBot.value = `nospam ${Utils.random(minRandom, maxRandom)}`;
        }
    }

    /**
     * Метод сбрасывает поля формы
     * @private
     */
    _resetForm() {
        this.inputList.forEach((item) => {
            item.clear();
        });

        this.form.reset();
    }

    /**
     * Устанавливает данные скрытому инпуту исходя из таргета попапа
     * @private
     */
    _setHiddenInputs() {
        if (!this.popupInstance || !this.popupInstance.currentTarget) {
            return;
        }
        const inputs = this.popupInstance.currentTarget.dataset.inputs;

        if (inputs) {
            const inputsArray = inputs.split(',');

            for (const item of inputsArray) {
                const data = item.split(':');
                const input = this.form.querySelector(`input[name="${data[0]}"]`);

                if (input) {
                    input.value = data[1];
                }
            }
        }
    }

    /**
     * Подменяет заголовок формы для особых кнопок
     * @private
     */
    _replaceTitle() {
        if (!this.popupInstance || !this.popupInstance.currentTarget) {
            return;
        }

        const buttonTitle = this.popupInstance.currentTarget.dataset.title;
        const formTitle = this.form.querySelector('.j-form-title');
        const formMessage = this.form.querySelector('.j-form-message');

        if (buttonTitle && formTitle) {
            formTitle.innerHTML = buttonTitle;
        }

        if (formMessage && buttonTitle) {
            formMessage.value = buttonTitle;
        }
    }

    /**
     * При необходимости устанавливает текущий url в скрытый инпут
     * @private
     */
    _setHiddenUrl() {
        const input = this.form.querySelector('input[name=url]');

        if (input) {
            input.value = window.location.href;
        }
    }

    /**
     * Выводит выбранную соцсеть в скрытые инпуты (только для кастомной формы лидов)
     * @private
     */
    _setHiddenUtmInputs() {
        const hiddenUtmSource = this.form.querySelector('input[name=utmSource]');
        const hiddenUtmMedium = this.form.querySelector('input[name=utmMedium]');
        const hiddenUtmCampaign = this.form.querySelector('input[name=utmCampaign]');
        const socials = Array.from(this.form.querySelectorAll('input[name=social]'));

        if (socials.length < 1) {
            return;
        }

        const current = socials.filter((item) => {
            return item.checked;
        });

        if (current.length < 1) {
            return;
        }

        if (hiddenUtmSource) {
            hiddenUtmSource.value = current[0].value;
        }

        if (hiddenUtmMedium) {
            hiddenUtmMedium.value = 'social';
        }

        if (hiddenUtmCampaign) {
            hiddenUtmCampaign.value = `rbinhouse_social_cpa_${current[0].value}_lead`;
        }
    }

    /**
     * Отправляет данные из форм в Mindbox - интеграция 2023 года
     * @private
     */
    /* eslint-disable max-lines-per-function, max-statements, no-undef */
    _sendMindboxNew() {
        if (!window.mindbox) {
            return;
        }

        const domain = window.location.hostname.split('.');
        let contactPoint = 'Main';

        if (domain[0] !== 'www' && domain[0] !== 'rbi') {
            contactPoint = domain[0];
        }

        if (this.form.classList.contains('j-mbox-call')) {
            // Потребитель заказал звонок через форму на сайте
            mindbox('async', {
                operation: 'CallRequest',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        mobilePhone  : this.formData.get('phone'),
                        ids          : {},
                        subscriptions: [{
                            pointOfContact: 'SMS',
                            isSubscribed  : false
                        }, {
                            pointOfContact: 'Viber',
                            isSubscribed  : false
                        }]
                    },
                    pointOfContact: contactPoint
                },
                onSuccess: () => {
                    console.warn('mindbox call - success');
                },
                onError: (error) => {
                    console.error('mindbox call - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-book-flat')) {
            // Потребитель оставил заявку на бронирование
            mindbox('async', {
                operation: 'ReservationRequest',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        mobilePhone  : this.formData.get('phone'),
                        ids          : {},
                        subscriptions: [{
                            pointOfContact: 'SMS',
                            isSubscribed  : false
                        }, {
                            pointOfContact: 'Viber',
                            isSubscribed  : false
                        }]
                    }
                },
                onSuccess: () => {
                    console.warn('mindbox booking - success');
                },
                onError: (error) => {
                    console.error('mindbox booking - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-booklet')) {
            // Потребитель заполнил форму “Скачать Буклет”
            const bookletBtn = document.querySelector('.j-popup-callback[data-fileid]');
            const bookletId = bookletBtn.getAttribute('data-fileid') || '';
            const bookletName = bookletBtn.getAttribute('data-name') || '';
            let operationName = bookletName ? bookletName : 'BookletDownload';

            // именные события для отдельных ЖК
            switch (contactPoint) {
                case 'repin':
                    operationName = 'Customer.BookletDownloadRepin';
                    break;
                case 'geniy':
                    operationName = 'Customer.BookletDownloadGeniy';
                    break;
                case 'litera':
                    operationName = 'Customer.BookletDownloadLitera';
                    break;
                case 'ultracity':
                    operationName = 'Customer.BookletDownloadUltraCity3';
                    break;
                case 'artstudio-m103':
                    operationName = 'Customer.BookletDownloadArtStudioM103';
                    break;
                default:
                    break;
            }

            mindbox('async', {
                operation: operationName,
                data     : {
                    customer: {
                        firstName: this.formData.get('first_name'),
                        email: this.formData.get('email'),
                        subscriptions: [
                            {
                                brand: 'rbiru',
                                pointOfContact: 'Email'
                            }
                        ]
                    /*
                        fullName     : this.formData.get('first_name'),
                        email        : this.formData.get('email'),
                        ids          : {},
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    */
                    },
                    pointOfContact: contactPoint,
                    emailMailing  : {
                        attachments: [{
                            fileName: 'Буклет.pdf',
                            body    : {
                                fileId: bookletId
                            }
                        }]
                    }
                },
                onSuccess: () => {
                    const ctSessionId = window.ct('calltracking_params', '10b4640d').sessionId;
                    const siteId = '1932';

                    console.log('ct session id?', ctSessionId);

                    if (ctSessionId) {пше
                        const ctData = {
                            fio       : this.formData.get('first_name'),
                            email     : this.formData.get('email'),
                            subject   : 'Скачан буклет',
                            requestUrl: location.href,
                            sessionId : ctSessionId
                        };
                        console.log('ct data:', ctData);

                        jQuery.ajax({
                            url     : `https://api.calltouch.ru/calls-service/RestAPI/requests/${siteId}/register/`,
                            dataType: 'json',
                            type    : 'POST',
                            data    : ctData
                        });
                    }

                    console.warn('mindbox booklet - success');
                },
                onError: (error) => {
                    console.error('mindbox booklet - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-discount')) {
            // Потребитель заполнил форму “Узнать Скидку”
            mindbox('async', {
                operation: 'RequestDiscount',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        ids          : {},
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    },
                    pointOfContact: contactPoint
                },
                onSuccess: () => {
                    console.warn('mindbox discount - success');
                },
                onError: (error) => {
                    console.error('mindbox discount - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-profitable')) {
            // Потребитель заполнил заявку на доходные программы
            mindbox('async', {
                operation: 'RequestRevenueProgram',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        mobilePhone  : this.formData.get('phone'),
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    }
                },
                onSuccess: () => {
                    console.warn('mindbox profitable - success');
                },
                onError: (error) => {
                    console.error('mindbox profitable - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-mortgage')) {
            // Потребитель заполнил форму “Заявка на ипотеку”
            mindbox('async', {
                operation: 'MortgageRequest',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        mobilePhone  : this.formData.get('phone'),
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    }
                },
                onSuccess: () => {
                    console.warn('mindbox mortgage - success');
                },
                onError: (error) => {
                    console.error('mindbox mortgage - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-installment')) {
            // Потребитель заполнил форму “Заявка на рассрочку”
            mindbox('async', {
                operation: 'InstallmentRequest',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        mobilePhone  : this.formData.get('phone'),
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    }
                },
                onSuccess: () => {
                    console.warn('mindbox installment - success');
                },
                onError: (error) => {
                    console.error('mindbox installment - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-webpush')) {
            // Потребитель заполнил форму подписки на вебпуш
            mindbox('async', {
                operation: 'EmailFromPush',
                data     : {
                    customer: {
                        email        : this.formData.get('email'),
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    },
                    pointOfContact: contactPoint
                },
                onSuccess: () => {
                    console.warn('mindbox webpush - success');
                },
                onError: (error) => {
                    console.error('mindbox webpush - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-request')) {
            // Потребитель записался на просмотр через Контакты
            mindbox('async', {
                operation: 'RequestView',
                data     : {
                    customer: {
                        email        : this.formData.get('email'),
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    },
                    pointOfContact: contactPoint
                },
                onSuccess: () => {
                    console.warn('mindbox request - success');
                },
                onError: (error) => {
                    console.error('mindbox request - error', error);
                }
            });
        }

        if (this.form.classList.contains('j-mbox-discount50')) {
            // Потребитель подписался на новости ради скидки
            mindbox('async', {
                operation: 'RequestDiscount50',
                data     : {
                    customer: {
                        fullName     : this.formData.get('first_name'),
                        email        : this.formData.get('email'),
                        subscriptions: [{
                            pointOfContact: 'Email',
                            isSubscribed  : true
                        }]
                    },
                    pointOfContact: contactPoint
                },
                onSuccess: () => {
                    console.warn('mindbox discount 50 - success');
                },
                onError: (error) => {
                    console.error('mindbox discount 50 - error', error);
                }
            });
        }
    }

    /**
     * Отправляет данные в Mindbox - старая интеграция
     * @private
     */
    // _sendMindboxData() {
    //     if (!window.mindbox) {
    //         return;
    //     }

    //     let pointOfContact = '';

    //     if (this.form.querySelector('[name="IdSubjectIncident"]')) {
    //         // эти коды взяты с бэковских файлов
    //         switch (this.form.querySelector('[name="IdSubjectIncident"]').value) {
    //             case 'FEC0D08C-D877-EA11-A2B5-00155D018035':
    //                 pointOfContact = 'ownership-rights';
    //                 break;
    //             case '3EB34A7F-1270-EA11-A2B5-00155D018035':
    //                 pointOfContact = 'replanning';
    //                 break;
    //             case '4D3FDF76-1270-EA11-A2B5-00155D018035':
    //                 pointOfContact = 'ozenka';
    //                 break;
    //             case '9BBC776D-D877-EA11-A2B5-00155D018035':
    //                 pointOfContact = 'pereustupka';
    //                 break;
    //             default:
    //                 pointOfContact = '';
    //                 break;
    //         }
    //     } else if (window.location.hostname === 'rbi.ru' && window.location.pathname === '/') {
    //         pointOfContact = 'rbiRuMain';
    //     } else {
    //         pointOfContact = 'rbiCommon';
    //     }

    //     // eslint-disable-next-line no-undef
    //     /* mindbox('async', {
    //         operation: 'ZakazalZvonokCherez',
    //         data     : {
    //             customer: {
    //                 fullName   : this.formData.get('first_name'),
    //                 mobilePhone: this.formData.get('phone'),
    //                 ids        : {
    //                     userWebSiteID: Cookie.get('clientId')
    //                 },
    //                 subscriptions: [{
    //                     pointOfContact: 'sms',
    //                     valueByDefault: true,
    //                     isSubscribed  : true
    //                 }]
    //             },
    //             pointOfContact
    //         }
    //     }); */
    // }

    _sendGA() {
        if (typeof ga === 'undefined') {
            return;
        }

        const sendFlatForm = this.wrapper.id === 'send-flat-form';

        if (sendFlatForm) {
            // eslint-disable-next-line no-undef
            ga('send', 'event', 'Form', 'Send', 'CallBack');
        }

        if (window.location.pathname === '/finishing/' && !this.popupInstance) {
            // форма с конструктора, туда не стала добавлять data-counter
            this.counterType = 'finishing-form';
        }
    }

    /* eslint-disable max-lines-per-function*/
    _sendDataLayer() {
        if (!this.counterType) {
            return;
        }

        window.dataLayer = window.dataLayer || [];

        const counterTypeArray = this.counterType.split(',');

        let GAlabel = false;
        let purchase = false;
        let flatId = null;
        let price = 0;

        for (const counterType of counterTypeArray) {
            switch (counterType) {
                case 'booking':
                    GAlabel = 'reservation';
                    break;
                case 'callback':
                    GAlabel = 'CallBack';
                    break;
                case 'request':
                    GAlabel = 'reservation-installment';
                    break;
                case 'sendFlat':
                    purchase = true;
                    flatId = this.formData.get('flatId') || this.formData.get('premiseId');
                    price = this.formData.get('price');
                    break;
                case 'finishing-form':
                    GAlabel = 'Лендинг для RBI OK';
                    break;
                case 'mortgage-callback':
                    GAlabel = 'mortgageapply';
                    break;
                default:
                    break;
            }
        }

        if (GAlabel) {
            window.dataLayer.push({
                event     : 'GAevent',
                GAcategory: 'form',
                GAaction  : 'send',
                GAlabel
            });
        }

        if (purchase && flatId) {
            window.dataLayer.push({
                event   : 'Purchase',
                products: [{
                    id: flatId,
                    price
                }]
            });
        }
    }
    /* eslint-enable max-lines-per-function */

    /**
     * Отправляет события в Hybrid при успешной отправке форм
     * @private
     */
    _sendHybrid() {
        // Заказать звонок
        if (this.form.classList.contains('j-hybrid-call')) {
            window._txq.push(['track', 'call']);
        }

        // Забронировать
        if (this.form.classList.contains('j-hybrid-booked')) {
            window._txq.push(['track', 'book_call']);
        }

        // НОВОЕ 2024
        // Скачать буклет
        if (this.form.classList.contains('j-hybrid-booklet')) {
            window._txq.push(['track', 'download']);
        }
    }

    /**
     * Отправляет данные в Criteo с форм заказа звонка и бронирования в карточке квартиры
     * @private
     */
    _sendCriteo() {
        if (!this.criteo) {
            return;
        }

        window.dataLayer = window.dataLayer || [];

        // отправка формы (бронирование и заказ звонка)
        window.dataLayer.push({
            event: 'crto_basketpage',
            crto : {
                email   : '',
                products: [{
                    id      : this.formData.get('flatId') || this.formData.get('premiseId'),
                    price   : this.formData.get('price'),
                    quantity: '1'
                }]
            }
        });

        // подтверждение номера телефона
        // transactionid - номер заявки с бэка
        window.dataLayer.push({
            event: 'crto_transactionpage',
            crto : {
                email        : '',
                transactionid: this.formDataResponse.id,
                products     : [{
                    id      : this.formData.get('flatId') || this.formData.get('premiseId'),
                    price   : this.formData.get('price'),
                    quantity: '1'
                }]
            }
        });
    }

    /**
     * Отправляет метрики
     * @private
     */
    _sendMetrics() {
        if (typeof fbq !== 'undefined') {
            // eslint-disable-next-line no-undef
            fbq('track', 'Lead');
        }

        if (typeof VK !== 'undefined') {
            // eslint-disable-next-line
            VK.Goal('lead');
        }

        if (typeof _tmr !== 'undefined') {
            // eslint-disable-next-line
            _tmr.push({ id: 'counterID', type: 'reachGoal', goal: 'Lead' });
        }
    }

    /**
     *  Записывает в куки данные сессии колтача для отправки по апи
     */
    _setCallTouchID() {
        if (!window.ct) {
            return;
        }

        if (window.ct('calltracking_params', 'mod_id')) {
            Cookie.set('_ct_session_id', window.ct('calltracking_params', 'mod_id')[0].sessionId);
        }
    }

    /**
     * Метод добавляет куку при успешной отправке формы подписки за скидку
     */
    _setCookie() {
        if (this.wrapper.id === 'discount-form') {
            const expirationDate = new Date();

            expirationDate.setFullYear(expirationDate.getFullYear() + 1);

            const newCookie = `subscribed=true; domain=rbi.ru; path=/; expires=${expirationDate.toUTCString()}`;

            document.cookie = newCookie;
        }
    }

    /**
     *  Показывает/прячет содержимое пароля
     */
    _togglePassword() {
        this.passwordToggleBtn.addEventListener('click', () => {
            if (this.passwordInput.type === 'password') {
                this.passwordInput.type = 'text';
                this.passwordToggleBtn.classList.add('is-active');
            } else if (this.passwordInput.type === 'text') {
                this.passwordInput.type = 'password';
                this.passwordToggleBtn.classList.remove('is-active');
            }
        });
    }

    /**
     *  Подменяет ссылку на кнопке при выборе типа формы
     * @private
     * @param {String} value - название формы, по которому подменяем ссылку
     */
    _changeButtonLink(value) {
        const pseudoButton = this.form.querySelector('.j-mutable-button');

        if (pseudoButton) {
            const name = value.textContent;

            if (name === 'форма для покупателя') {
                pseudoButton.setAttribute('href', '/manager/customer/');
            } else if (name === 'форма сделки') {
                pseudoButton.setAttribute('href', '/manager/deal/');
            } else if (name === 'форма для продавца') {
                pseudoButton.setAttribute('href', '/manager/salesman/');
            } else {
                pseudoButton.setAttribute('href', '');
            }
        }
    }
}

export default Form;
